import { takeLatest, call, put } from 'redux-saga/effects';
import {
  FETCH_TASK_FILE_CONFIGS,
  fetchTaskFileConfigsSuccess,
  fetchTaskFileConfigsFailed,
  fetchingTaskFileConfigs,
} from '../actions/taskfileconfigs';

import { firestore, getTenantPath } from '../utils/firebase';
import { toArray, convertCollection } from '../utils/helper';

function fetchTaskFileConfigs() {
  return new Promise((resolve) => {
    firestore.collection(getTenantPath('/taskfileconfigs'))
      .get()
      .then(convertCollection)
      .then((data) => {
        resolve(toArray(data));
      });
  });
}

function* fetchTaskFileConfigsSaga() {
  try {
    yield put(fetchingTaskFileConfigs());
    const tasks = yield call(fetchTaskFileConfigs);
    yield put(fetchTaskFileConfigsSuccess(tasks));
  } catch (e) {
    yield put(fetchTaskFileConfigsFailed(e));
  }
}

function* watchFetchTaskFileConfigsSaga() {
  yield takeLatest(FETCH_TASK_FILE_CONFIGS, fetchTaskFileConfigsSaga);
}

export {
  fetchTaskFileConfigsSaga,
  watchFetchTaskFileConfigsSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/taskfileconfigs.js